import { useEffect } from "react"
import { BlockchainNetwork } from "@renec-foundation/relend-adapter"
import { useAtomValue } from "jotai"
import { networkAtom } from "@/atoms/settings"
import useMutableSearchParams from "./useMutableSearchParams"
import useLocalStorage from "./useLocalStorage"

const useMarketSelection = () => {
  const [, setSelectedMarket] = useLocalStorage("selectedMarket", BlockchainNetwork.SOLANA.toLowerCase())
  const [trackingUTM, setTrackingUTM] = useLocalStorage("trackingUTM", "{}")
  const { params: queryParams, replaceState } = useMutableSearchParams()
  const network = useAtomValue(networkAtom)

  useEffect(() => {
    const marketParam = queryParams.market?.toLowerCase()
    if (marketParam) return

    const market = network.toLowerCase()
    replaceState({ market })
    setSelectedMarket(market)
  }, [network, queryParams.market, replaceState, setSelectedMarket])

  useEffect(() => {
    const utm_source = queryParams.utm_source?.toLowerCase()
    const utm_medium = queryParams.utm_medium?.toLowerCase()
    const utm_campaign = queryParams.utm_campaign?.toLowerCase()

    const dataTrackingSaved = JSON.parse(trackingUTM)
    const dataTracking = {
      utm_source: utm_source ?? dataTrackingSaved.utm_source ?? "None",
      utm_medium: utm_medium ?? dataTrackingSaved.utm_medium ?? "None",
      utm_campaign: utm_campaign ?? dataTrackingSaved.utm_campaign ?? "None",
    }

    setTrackingUTM(JSON.stringify(dataTracking))
  }, [queryParams.utm_source, queryParams.utm_medium, queryParams.utm_campaign, trackingUTM, setTrackingUTM])
}

export default useMarketSelection
